define('ordersUnpaidTableView',[
  'module',
  'ordersListView',
  'ordersUnpaidFiltersView'
], function (
  Module,
  OrdersListView,
  FiltersView
) {
  'use strict';

  Module.exports = OrdersListView.extend({
    className: 'unpaid-orders-table-view ' + OrdersListView.prototype.className,
    filtersViewClass: FiltersView,

    getFiltersParams: function() {
      var params = OrdersListView.prototype.getFiltersParams.apply(this, arguments);
      // The whole screen is scoped to unpaid orders sitting in an "order due" status
      params.payedByCustomer = 'false';
      params.orderDue = 'true';
      params.excludedStatuses = 'CANCELLED,DECLINED';
      return params;
    }
  });
});

